import { ShoppingBag } from "lucide-react";
import { useCart } from "@/shop/CartContext";
import { inr, savingsBadge, offLabel } from "@/shop/products";

const ProductCard = ({ product }) => {
  const { add } = useCart();
  const off = offLabel(product);
  const save = savingsBadge(product);
  const inStock = product.in_stock !== false;

  return (
    <article
      data-testid={`product-card-${product.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#121212] transition-colors duration-300 hover:border-[#7ED321]/40"
    >
      <a href={`/products/${product.slug}`} className="relative block overflow-hidden" data-testid={`product-link-${product.slug}`}>
        <img
          src={product.image}
          alt={product.title}
          loading="lazy"
          className="aspect-[4/3] w-full bg-[#0c0e0b] object-contain p-8 transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {save && (
          <span className="absolute left-3 top-3 rounded-full bg-[#1A4D2E] px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-[#b7e389]">
            {save}
          </span>
        )}
        {!inStock && (
          <span className="absolute right-3 top-3 rounded-full bg-[#3a1215] px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-[#f3a6a6]" data-testid={`out-of-stock-${product.slug}`}>
            Out of Stock
          </span>
        )}
      </a>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg uppercase leading-tight tracking-wide text-white">
          {product.title}
        </h3>
        <p className="mt-1 text-[11px] uppercase tracking-[0.15em] text-white/40">{product.short}</p>
        <p className="mt-3 text-xs leading-relaxed text-[#A6A66A]">{product.description}</p>
        <p className="mt-2 flex-1 text-[11px] leading-relaxed text-white/40">{product.nutrition}</p>
        <div className="mt-4 flex items-baseline gap-2">
          <span className="font-display text-2xl text-white" data-testid={`product-price-${product.slug}`}>
            {inr(product.price)}
          </span>
          {product.compareAt && (
            <>
              <span className="text-sm text-white/35 line-through">{inr(product.compareAt)}</span>
              <span className="text-[11px] font-semibold text-[#7ED321]">{off}</span>
            </>
          )}
        </div>
        <button
          onClick={() => add(product.slug)}
          disabled={!inStock}
          data-testid={`add-to-cart-${product.slug}`}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-[#7ED321] py-3.5 text-xs font-bold uppercase tracking-[0.12em] text-[#0A0A0A] transition-colors duration-300 hover:bg-[#8FE331] disabled:cursor-not-allowed disabled:bg-white/10 disabled:text-white/40 disabled:hover:bg-white/10"
        >
          <ShoppingBag className="h-4 w-4" />
          {inStock ? "Add to Cart" : "Out of Stock"}
        </button>
      </div>
    </article>
  );
};

export default ProductCard;
